import React from 'react';
import phoneWarning from '../assets/images/phoneWarning.png';

const PhoneView: React.FC = () => {
  return (
    <div className="w-full h-screen bg-dark_green flex justify-center items-center flex-col">
      <img src={phoneWarning} alt="Phone warning" />
      <div className="text-black text-center text-base sm:text-lg md:text-xl mt-4">
        <p>Mobile preview is not available.</p>
        <p>Please open on a TV, desktop, or web browser.</p>
      </div>
    </div>
  );
};

export default PhoneView;
